import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import Forbidden from 'components/Forbidden';

export const Route = createFileRoute('/forbidden')({
  component: ForbiddenComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      homePathUri: (search.homePathUri as string) || undefined,
    };
  },
});

function ForbiddenComponent() {
  const search = Route.useSearch();
  return <Forbidden homePathUri={search.homePathUri} />;
}
